$(function () {
    if($(window).width() > 768){
        $('table.sticky-header-table').floatThead();
    }else{
        $(".custom-responsive-table .model-row td").not('.model-name-row').hide();
        $(".model-name-row").click(function () {
            var visible = false;
            if($(this).hasClass('opened')){
                visible = true;
            }
            $(".custom-responsive-table .model-row td.model-name-row").removeClass('opened');
            $(".custom-responsive-table .model-row td").not('.model-name-row:visible').slideUp();
            if(!visible){
                $(this).addClass('opened');
                $(this).closest('tr').find('td').slideDown();
            }
        });
    }
});